import axios from 'axios';

const AM_LOADMORE_TRIGGERS_SELECTOR = 'data-load-more'
const AM_LOADMORE_CONTAINER_SELECTOR = 'data-load-more-container'
const AM_LOADMORE_ITEMS_TOTAL = 'data-load-more-items-total'
const AM_LOADMORE_ITEMS_FROM = 'data-load-more-items-from'
const AM_LOADMORE_ITEMS_LIMIT = 'data-load-more-items-limit'

// use this to avoid requests spamming
const cancelToken = axios.cancelToken;
let cancel;

function init(){
  const $triggers = document.querySelectorAll(`[${AM_LOADMORE_TRIGGERS_SELECTOR}]`)
  if ($triggers.length === 0) return
  initLoaders($triggers)
}

function initLoaders($triggers) {
  $triggers.forEach($trigger => {
    const container = $trigger.getAttribute(AM_LOADMORE_CONTAINER_SELECTOR)
    const $container = document.getElementById(container)
    const itemsTotal = parseInt($trigger.getAttribute(AM_LOADMORE_ITEMS_TOTAL), 10)
    const itemsLimit = parseInt($trigger.getAttribute(AM_LOADMORE_ITEMS_LIMIT), 10)

    if (typeof itemsTotal === undefined) {
      const itemsTotal = 0
    }
    if (typeof itemsOffset === undefined) {
      const itemsOffset = 0
    }

    if ($trigger.length === 0) return;

    $trigger.addEventListener('click', (e) => {
      let url = $trigger.getAttribute(AM_LOADMORE_TRIGGERS_SELECTOR);
      const itemsFrom = parseInt($trigger.getAttribute(AM_LOADMORE_ITEMS_FROM), 10)

      // add limit settings to URL
      if (itemsFrom && itemsLimit && itemsTotal) {
        url+= `&from=${itemsFrom}&limit=${itemsLimit}`;
      }

      // cancel previous request
      if (typeof cancel === 'function') {
        cancel();
      }
      // run request
      axios
        .get(url, {
          // cancel if previous one
          cancelToken: new axios.CancelToken(function executor(c) {
            cancel = c;
          })
        })
        .then((response) => {
          if (response.data) {
            $container.innerHTML+= response.data
            const itemsFromNew = itemsFrom + itemsLimit;
            if (itemsFromNew > itemsTotal) {
              $trigger.style.display = 'none';
            } else {
            const itemsFromNew = itemsFrom + itemsLimit;
            $trigger.setAttribute(AM_LOADMORE_ITEMS_FROM, itemsFromNew);
            }
          }
        })
    })
  })
}


export default { init }
